import moment from "moment"
import React, { useEffect, useState } from "react"
import {
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  Modal,
  Row,
  Badge,
  Spinner,
  Alert,
} from "react-bootstrap"

import "./visit.css"

import AssignCustomer from "../Customers/AssignCustomer"
import AssignUser from "../Users/AssignUser"
import API from "../../common/API"
import AddEditVisit from "./AddEditVisit"
import { parsedUser } from "../../common/GetCurrentUser"
import { useHistory } from "react-router-dom"
import ModernImageViewer from "../Common/ModernImageViewer"

import ModernVisitGallery from "./ModernVisitGallery"
import VisitMap from "./VisitMap"
import AddEditPlace from "./AddEditPlace"
import { useTranslation } from "react-i18next"
import AssignPlaceStatus from "./AssignPlaceStatus"
import VisitList from "./VisitList"
import { Routes } from "../../routes"
import VehicleVisit from "./VehicleVisit"
import Summary from "./VisitDetails/Summary"
import OchoaDetails from "./VisitDetails/OchoaDetails"

const VisitDetails = props => {
  const [model, setModel] = useState(props.model)
  const user = parsedUser()
  const [section, setSection] = useState("shearlybi")
  const history = useHistory()
  const { t } = useTranslation("global")
  const [showAssignCustomer, setShowAssignCustomer] = useState(false)
  const [AssignUserType, setAssignUserType] = useState(null)
  const toggleAssignCustomer = () => {
    setShowAssignCustomer(!showAssignCustomer)
    if (showAssignCustomer) {
      requestDetails()
    }
  }
  const [visits, setVisits] = useState([])

  const requestVisits = async () => {
    let query = "placeId=" + model.id
    // query += "&OrganizationId=" + user.OrganizationId;
    let requestAPI = await API.getAction("place/VisitList", query)
    if (requestAPI.data.status === "ok") {
      setVisits(requestAPI.data.response)
    }
  }

  const [totals, setTotals] = useState({
    totalApartments: 0,
    totalRoomsPerApartment: 0,
    totalBathrooms: 0,
    totalHabitableArea: 0,
    totalNonHabitableArea: 0,
  })

  const requestDetails = async () => {
    let query = "id=" + model.id + "&userId=" + user.ID
    // query += "&OrganizationId=" + user.OrganizationId;
    let requestAPI = await API.getAction("place/Details", query)
    if (requestAPI.data.status === "ok") {
      let details = requestAPI.data.response
      setModel(requestAPI.data.response)

      let totalApartments = 0,
        totalRoomsPerApartment = 0,
        totalBathrooms = 0,
        totalHabitableArea = 0,
        totalNonHabitableArea = 0

      totalApartments =
        details.quantityOfFloor * 1 * details.departmentPerFloor * 1
      totalRoomsPerApartment = totalApartments * details.roomsPerApartment * 1

      totalBathrooms = totalRoomsPerApartment * 1.25

      totalHabitableArea =
        details.quantityOfFloor *
        1 *
        details.departmentPerFloor *
        1 *
        details.estimatedDimensions *
        1

      totalNonHabitableArea = totalHabitableArea * 0.2

      setTotals({
        ...totals,
        totalApartments: totalApartments,
        totalRoomsPerApartment: totalRoomsPerApartment,
        totalBathrooms: totalBathrooms,
        totalHabitableArea: totalHabitableArea,
        totalNonHabitableArea: totalNonHabitableArea,
      })
    }
  }

  const [showAddEditVisit, setShowAddEditVisit] = useState(false)
  const toggleAddEditVisit = () => {
    setShowAddEditVisit(!showAddEditVisit)
  }

  useEffect(() => {
    if (model) {
      requestVisits()
    }
  }, [model])

  useEffect(() => {
    requestDetails()
  }, [])

  const [showAddEdit, setShowAddEdit] = useState(false)
  const toggleAddEdit = () => {
    setShowAddEdit(!showAddEdit)
    if (showAddEdit) {
      requestDetails()
    }
  }

  const [showAssignUsers, setShowAssignUsers] = useState(false)
  const toggleAssignUsers = type => {
    setShowAssignUsers(!showAssignUsers)
    if (showAssignUsers) {
      requestDetails()
    }
    setAssignUserType(type)
  }
  const [isLoading, setIsLoading] = useState(false)
  const savePlace = async () => {
    try {
      setIsLoading(true)
      let request = await API.postAction("place/AddEdit", model)

      console.log(request)
      if (request.data.status === "ok") {
        requestDetails()
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }
  const createChat = async () => {
    try {
      let query = {
        placeId: model.id,
        createdById: user.ID,
      }
      let request = await API.postAction("chat/createChat", query)
      console.log(request)
      if (request) {
        history.push(`/chat/${request.data.response.chatId}`)
      }
    } catch (ex) {
      console.error(ex)
    }
  }
  const [showAssignStatus, setShowAssignStatus] = useState(false)
  const toggleAssignStatus = () => {
    setShowAssignStatus(!showAssignStatus)
    if (showAssignStatus) {
      requestDetails()
    }
  }
  const [showMap, setShowMap] = useState(true)
  const toggleMap = () => {
    setShowMap(!showMap)
  }

  const [showPhoto, setShowPhoto] = useState(true)
  const togglePhoto = () => {
    setShowPhoto(!showPhoto)
  }
  const togglePlacePriority = async (placeId, userId) => {
    try {
      setIsLoading(true)
      let query = `placeId=${placeId}&accountId=${userId}&assignedById=${user.ID}`
      let request = await API.getAction("place/AssignToPriority?" + query)
      if (request.data.status === "ok") {
        requestDetails()
      } else {
        console.error(request.data.response)
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }
  if (!model) {
    return <></>
  }

  return (
    <>
      {/* ADDITIONAL SCREENS  */}
      {showAddEditVisit && (
        <AddEditVisit
          show={showAddEditVisit}
          toggle={toggleAddEditVisit}
          place={model}
        />
      )}
      {showAddEdit && (
        <AddEditPlace show={showAddEdit} toggle={toggleAddEdit} model={model} />
      )}
      {/* {showCategory ? <PhotoCategoryAssign show={showCategory} toggle={toggleShowCategory} PhotoId={selectedPhoto} /> : null} */}
      {showAssignCustomer ? (
        <AssignCustomer
          show={showAssignCustomer}
          toggle={toggleAssignCustomer}
          place={model}
        />
      ) : null}
      {showAssignUsers ? (
        <AssignUser
          show={showAssignUsers}
          toggle={toggleAssignUsers}
          type={AssignUserType}
          place={model}
        />
      ) : null}
      {showAssignStatus ? (
        <AssignPlaceStatus
          show={true}
          toggle={toggleAssignStatus}
          place={model}
        />
      ) : null}
      <Modal
        show={props.show}
        onHide={props.toggle}
        size="xl"
        className="modalRight"
      >
        <Modal.Header closeButton>
          <Row className="mx-0 w-100">
            <Col>
              <div className="d-flex align-items-center">
                <h3 className="mb-0 me-2">{model.name}</h3>

                {/* Status Badge */}
                {/* {model.placeStatus && (
                  <Badge
                    bg="light"
                    text="dark"
                    className="me-2 d-flex align-items-center"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <i
                      className={`${
                        model.placeStatus.icon || "fa fa-circle"
                      } me-1`}
                      style={{ color: model.placeStatus.color }}
                    ></i>
                    {model.placeStatus.name}
                  </Badge>
                )} */}

                {/* Priority Button */}
                <Dropdown as={ButtonGroup} size="sm">
                  <Button
                    variant={
                      model.isInPriority ? "warning" : "outline-secondary"
                    }
                    onClick={() => togglePlacePriority(model.id, user.ID)}
                    disabled={isLoading}
                    title={
                      model.isInPriority
                        ? t("Remove from priority")
                        : t("Add to priority")
                    }
                  >
                    <i className="fa fa-star"></i>
                  </Button>

                  <Dropdown.Toggle
                    split
                    variant={
                      model.isInPriority ? "warning" : "outline-secondary"
                    }
                    id="dropdown-priority"
                  >
                    <i className="fa fa-caret-down"></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => toggleAssignUsers("priority")}
                    >
                      <i className="fa fa-user me-2"></i>
                      {t("Assign to user")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            <Col className="text-end">
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => toggleAddEdit()}
                  disabled={isLoading}
                >
                  <i className="fa fa-edit me-2"></i>
                  <span className="d-none d-md-inline">{t("Edit")}</span>
                </Button>

                <Button
                  variant={showMap ? "primary" : "outline-secondary"}
                  size="sm"
                  onClick={() => toggleMap()}
                >
                  <i className="fa fa-map me-2"></i>
                  <span className="d-none d-md-inline">{t("Map")}</span>
                </Button>

                <Button
                  variant={showPhoto ? "primary" : "outline-secondary"}
                  size="sm"
                  onClick={() => togglePhoto()}
                >
                  <i className="fa fa-images me-2"></i>
                  <span className="d-none d-md-inline">{t("Photos")}</span>
                </Button>

                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={() => createChat()}
                >
                  <i className="fa fa-comments "></i>
                  <span className="d-none d-md-inline">{t("Chat")}</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ overflow: "auto" }}>
          <Container>
            <Row class>
              <Col xs={12} md={12} xl={4} className="p-0">
                <Card className="shadow-sm m-2">
                  {model.image && (
                    <ModernImageViewer
                      imagePath={model.image}
                      alt={model.name || "Place image"}
                      maxHeight="250px"
                      className="card-img-top"
                    />
                  )}

                  <Card.Body className="p-0">
                    <div className="table-responsive">
                      <table className="table table-striped mb-0">
                        <tbody>
                          <tr>
                            <td
                              className="fw-bold text-muted"
                              style={{ width: "40%" }}
                            >
                              {t("Assigned to")}
                            </td>
                            <td>
                              {model.assignedTo ? (
                                <Button
                                  variant="outline-primary"
                                  size="sm"
                                  onClick={() => toggleAssignUsers()}
                                  className="d-flex align-items-center"
                                >
                                  <i className="fa fa-user me-2"></i>
                                  {model.assignedToObj?.firstName}{" "}
                                  {model.assignedToObj?.lastName}
                                </Button>
                              ) : (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() => toggleAssignUsers()}
                                >
                                  <i className="fa fa-plus me-2"></i>
                                  {t("Assign")}
                                </Button>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold text-muted">
                              {t("Reasign Visit")}
                            </td>
                            <td>
                              {model.revisitTo ? (
                                <Button
                                  variant="outline-warning"
                                  size="sm"
                                  onClick={() => toggleAssignUsers("revisit")}
                                  className="d-flex align-items-center"
                                >
                                  <i className="fa fa-redo me-2"></i>
                                  {model.revisitTo.firstName}{" "}
                                  {model.revisitTo.lastName}
                                </Button>
                              ) : (
                                <Button
                                  variant="warning"
                                  size="sm"
                                  onClick={() => toggleAssignUsers("revisit")}
                                >
                                  <i className="fa fa-redo me-2"></i>
                                  {t("Assign")}
                                </Button>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold text-muted">
                              {t("Customer")}
                            </td>
                            <td>
                              {model.customer ? (
                                <div className="d-flex align-items-center gap-2">
                                  <span
                                    onClick={() => {
                                      history.push(
                                        `${Routes.CustomerDetails.clean}${model.customer.id}`
                                      )
                                    }}
                                    className="text-primary fw-bold"
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    <i className="fa fa-building me-1"></i>
                                    {model.customer.name}
                                  </span>
                                  <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={() => toggleAssignCustomer()}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </Button>
                                </div>
                              ) : (
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  onClick={() => toggleAssignCustomer()}
                                >
                                  <i className="fa fa-link me-2"></i>
                                  {t("Link")}
                                </Button>
                              )}
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold text-muted">
                              {t("Status")}
                            </td>
                            <td>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => toggleAssignStatus()}
                                className="d-flex align-items-center"
                              >
                                <i
                                  className={`${
                                    model.placeStatus?.icon || "fa fa-circle"
                                  } me-2`}
                                  style={{
                                    color:
                                      model.placeStatus?.color || "#6c757d",
                                  }}
                                ></i>
                                {model.placeStatus?.name || "N/A"}
                              </Button>
                            </td>
                          </tr>

                          {/* Category */}
                          {model.category && (
                            <tr>
                              <td className="fw-bold text-muted">
                                {t("Category")}
                              </td>
                              <td>
                                <Badge bg="info" text="white">
                                  {model.category.name}
                                </Badge>
                              </td>
                            </tr>
                          )}

                          {/* Stage */}
                          {model.stage && (
                            <tr>
                              <td className="fw-bold text-muted">
                                {t("Stage")}
                              </td>
                              <td>
                                <Badge bg="success" text="white">
                                  {model.stage.name}
                                </Badge>
                              </td>
                            </tr>
                          )}

                          <tr>
                            <td className="fw-bold text-muted">
                              {t("Date of creation")}
                            </td>
                            <td>
                              <small className="text-muted">
                                <i className="fa fa-calendar me-1"></i>
                                {moment(model.created).fromNow()}
                              </small>
                            </td>
                          </tr>

                          <tr>
                            <td className="fw-bold text-muted">
                              {t("Created by")}
                            </td>
                            <td>
                              <small className="text-muted">
                                <i className="fa fa-user me-1"></i>
                                {model.createdBy
                                  ? `${model.createdBy.firstName} ${model.createdBy.lastName}`
                                  : "N/A"}
                              </small>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>

                  <Card.Footer>
                    <Button
                      variant="secondary"
                      className="w-100"
                      onClick={() => toggleAddEditVisit()}
                    >
                      <i className="fa fa-plus me-2"></i>
                      {t("Add visit")}
                    </Button>
                  </Card.Footer>
                </Card>
                {/* TECHNICAL DETAILS */}
                <Card className="shadow-sm m-2">
                  <Card.Header className="p-1 px-2">
                    <Card.Title> {t("Technical details")}</Card.Title>
                  </Card.Header>
                  <Card.Body className=" bg-light">
                    <Row>
                      <Col xs={12} md={6}>
                        <label>{t("Quantity of Floors")}</label>
                        <br />
                        <input
                          type="number"
                          className="form-control"
                          value={model.quantityOfFloor}
                          onChange={e => {
                            setModel({
                              ...model,
                              quantityOfFloor: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>

                      <Col xs={12} md={6}>
                        <label>{t("Apto. por piso")}</label>
                        <br />
                        <input
                          type="number"
                          className="form-control"
                          value={model.departmentPerFloor}
                          onChange={e => {
                            setModel({
                              ...model,
                              departmentPerFloor: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>
                      <Col xs={12} className="mt-2">
                        <label>{t("Habitaciones por apt.")}</label>
                        <br />
                        <input
                          type="number"
                          className="form-control"
                          value={model.roomsPerApartment}
                          onChange={e => {
                            setModel({
                              ...model,
                              roomsPerApartment: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>
                      <Col xs={12} className="mt-2">
                        <label>{t("Estimated Dimensions")}</label>
                        <br />
                        <input
                          type="number"
                          className="form-control"
                          value={model.estimatedDimensions}
                          onChange={e => {
                            setModel({
                              ...model,
                              estimatedDimensions: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>
                      <Col xs={12} md={6} className="mt-2">
                        <label>{t("Credit Code")}</label>
                        <br />
                        <input
                          type="text"
                          className="form-control"
                          value={model.creditCode}
                          onChange={e => {
                            setModel({
                              ...model,
                              creditCode: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>
                      <Col xs={12} md={6} className="mt-2">
                        <label>{t("Work Code")}</label>
                        <br />
                        <input
                          type="text"
                          className="form-control"
                          value={model.workCode}
                          onChange={e => {
                            setModel({
                              ...model,
                              workCode: e.target.value,
                            })
                          }}
                        ></input>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer>
                    <button
                      disabled={isLoading}
                      className="btn btn-block btn-primary"
                      onClick={() => savePlace()}
                    >
                      <i className="fa fa-save me-2"></i>
                      {t("Save")}
                    </button>
                  </Card.Footer>
                </Card>

                {/* VOL table */}
                {totals && totals.totalApartments > 0 && (
                  <Card className="shadow-sm m-2">
                    <Card.Header className="p-1 px-2">
                      <Card.Title> {t("Volume table")}</Card.Title>
                    </Card.Header>
                    <Card.Body className=" bg-light">
                      <Row>
                        <Col xs={12}>
                          <label>{t("Unidades de apto.")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={totals.totalApartments}
                          ></input>
                        </Col>
                        <Col xs={12}>
                          <label>{t("Habitaciones por apto.")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={totals.totalRoomsPerApartment}
                          ></input>
                        </Col>
                        <Col xs={12}>
                          <label>{t("No. de Baños")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={totals.totalBathrooms}
                          ></input>
                        </Col>

                        <Col xs={12}>
                          <label>{t("Área vivible mt²)")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={totals.totalHabitableArea}
                            onChange={e => {
                              setModel({
                                ...model,
                                quantityOfFloor: e.target.value,
                              })
                            }}
                          ></input>
                        </Col>

                        <Col xs={12}>
                          <label>{t("Área comun  mt²")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={totals.totalNonHabitableArea}
                            onChange={e => {
                              setModel({
                                ...model,
                                quantityOfFloor: e.target.value,
                              })
                            }}
                          ></input>
                        </Col>
                        <Col xs={12}>
                          <label>{t("Total  mt²")}</label>
                          <br />
                          <input
                            type="number"
                            disabled
                            className="form-control"
                            value={
                              totals.totalNonHabitableArea +
                              totals.totalHabitableArea
                            }
                            onChange={e => {
                              setModel({
                                ...model,
                                quantityOfFloor: e.target.value,
                              })
                            }}
                          ></input>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                )}
              </Col>

              <Col xs={12} md={12} lg={8}>
                <Container className="pt-4">
                  <ul className="nav nav-pills nav-justified">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          section === "summary" ? "active" : ""
                        }`}
                        aria-current="page"
                        onClick={() => {
                          setSection("summary")
                        }}
                      >
                        Summary
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          section === "shearlybi" ? "active" : ""
                        }`}
                        onClick={() => {
                          setSection("shearlybi")
                        }}
                      >
                        Shearly BI
                      </button>
                    </li>
                    {model.organizationId?.includes("ochoa") && (
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            section === "ochoa" ? "active" : ""
                          }`}
                          onClick={() => {
                            setSection("ochoa")
                          }}
                        >
                          Ochoa
                        </button>
                      </li>
                    )}
                  </ul>
                  {/* SUMMARY */}
                  {section === "summary" && <Summary model={model} />}
                  {/* OCHOA */}
                  {section === "ochoa" && <OchoaDetails model={model} />}
                  {/* VISITS SECTION */}
                  {section === "shearlybi" && (
                    <>
                      <div className="d-flex align-items-center justify-content-between mb-4">
                        <div>
                          <h4 className="mb-1 d-flex align-items-center">
                            <i className="fa fa-camera me-2 text-primary"></i>
                            {t("Visits")}
                          </h4>
                          <p className="text-muted mb-0">
                            {visits.length > 0
                              ? `${visits.length} ${
                                  visits.length === 1
                                    ? t("Registered visit")
                                    : t("Registered visits")
                                }`
                              : t("No registered visits")}
                          </p>
                        </div>
                        {visits.length > 0 && (
                          <Badge
                            bg="primary"
                            className="d-flex align-items-center"
                          >
                            <i className="fa fa-images me-1"></i>
                            {visits.length}
                          </Badge>
                        )}
                      </div>

                      <div className="visits-instagram-container">
                        <VisitList visits={visits} />
                      </div>

                      <VehicleVisit id={model.id} />
                      {showPhoto && (
                        <Card className="my-4 shadow-sm">
                          <Card.Body className="p-0">
                            <ModernVisitGallery id={model.id} />
                          </Card.Body>
                        </Card>
                      )}
                      {/* MAP */}
                      {showMap && <VisitMap model={model} />}
                    </>
                  )}
                </Container>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className="p-1"></Modal.Footer>
      </Modal>
    </>
  )
}

export default VisitDetails
